module.exports = __webpack_public_path__ + "static/img/card_feature_bg_01.4ea1bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rescuelist/card_feature_bg_01.png
// module id = 0+Au
// module chunks = 1